// offset is 10% of available size
import { PrintArea } from '@/types';

export const getOffset = ({
  boundary: {
    size: { width, height },
  },
}: PrintArea): [number, number] => [width / 10, height / 10];
